import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import {  Grid } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import TextButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Orders from './components/Order/Orders';
import Parcels from './components/Parcel/Orders';
import HistoryOrders from './components/Order/HistoryOrders';
import ParcelHistoryOrders from './components/Parcel/HistoryOrders';
import Manifest from './components/Parcel/Manifest/Manifest'
import ManifestHistory from './components/Parcel/Manifest/ManifestHistory'
import CustomerOrders from './components/Order/CustomerOrders';
import ServiceProvider from 'serviceProvider/ServiceProvider';
import CustChatListDialog from './components/Order/CustChatListDialog';
import ChatListDialog from './components/Order/ChatListDialog';
import ParcelChatListDialog from './components/Parcel/ChatListDialog';
import Tracker from 'shipTracker/Tracker';
import Users from './users/Users';
import OrderStagesTimeline from './components/orderStagesTimeline/OrderStagesTimeline';
import './MainPage.scss';
import { REQUEST_ACTIONS, sendRequest, setUID } from 'utils/Communicator';
import PredefinedDataSettings from 'components/settings/PredefinedDataSettings';
// import { snackbarToggle } from 'reducers/snackbarSlicer';
import CustomerConatiner from 'components/customer/customerConatiner/CustomerConatiner';
import OrderAssistant from 'components/customer/assistant/OrderAssistant';
import CustomerDashboard from 'components/customer/dashboard/CustomerDashboard';
import CustomerShipments from 'components/customer/shipments/CustomerShipments';
import Settings from 'components/customer/common/Settings/Settings';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import { Dialog } from 'style-guide';
import AddUser from './users/AddUser';
import AuditLogs from './audit/AuditLogs';
import { useDispatch } from 'react-redux';
import { getOrders, onParcelPageChange } from 'reducers/parcel-reducers/ordersSlicer';
import { onPageChange } from 'reducers/order-reducers/ordersSlicer';
import { onSearchChange } from 'reducers/order-reducers/orderTableFilterSlicer';
import CustomsUIPage from './components/CustomsData/CustomsUIPage';

const MainPage = () => {
    const dispatch = useDispatch();
    const { selectedLocationIndex } = useSelector(state => state.orderTableFilter);
    const [openChatNotificationDialog, setOpenChatNotificationDialog] = useState(false);
    const onHandleOpenChatNotificationDialog = () => setOpenChatNotificationDialog(true);
    const onHandleCancelChatNotificationDialog = () => setOpenChatNotificationDialog(false);

    const [openCustChatNotificationDialog, setOpenCustChatNotificationDialog] = useState(false);
    const onHandleOpenCustChatNotificationDialog = () => setOpenCustChatNotificationDialog(true);
    const onHandleCancelCustChatNotificationDialog = () => setOpenCustChatNotificationDialog(false);

    const [isUsTime, setIsUsTime] = useState(false);
    const [openProfileDialog, setOpenProfileDialog] = useState(false);
    const onHandleOpenProfileDialog = () => { handleClose(); setOpenProfileDialog(true); }
    const onHandleCancelProfileDialog = () => setOpenProfileDialog(false);

    const [openAuditLogsDialog, setOpenAuditLogsDialog] = useState(false);
    const onHandleOpenAuditLogsDialog = () => { handleClose(); setOpenAuditLogsDialog(true); }
    const onHandleCancelAuditLogsDialog = () => setOpenAuditLogsDialog(false);

    const [showCustomerNotification, setShowCustomerNotification] = useState(false);
    const onHandleOpenCustomerNotification = () => { setShowCustomerNotification(true); }
    const onHandleCancelCustomerNotification = () => setShowCustomerNotification(false);


    const [chatCountCust, setChatCountCust] = useState(0);
    const [chatOpenFunction, setChatOpenFunction] = useState(null);
    const [chatOpenOrder, setChatOpenOrder] = useState(1);

    const [filterSpinner, setFilterSpinner] = useState(false);

    const [openUsersDialog, setOpenUsersDialog] = useState(false);
    const onHandleOpenUsersDialog = () => { handleClose(); setOpenUsersDialog(true); }
    const onHandleCancelUsersDialog = () => {
        //console.log(window.location)
        setOpenUsersDialog(false);
        /*if (window.location.pathname === '/home') {
            navigate("/settings/users")
            //console.log(selectedLocationIndex + "   selectedLocationIndex")
            window.setTimeout(function () {
                navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
            }, 0)
        }*/
    }

    const [openCRMDialog, setOpenCRMDialog] = useState(false);
    const onHandleOpenCRMDialog = () => { handleClose(); setOpenCRMDialog(true); }
    const onHandleCancelCRMDialog = () => {
        setOpenCRMDialog(false);       
        /*if (window.location.pathname === '/home') {
            navigate("/settings/serviceProviders")
            //console.log(selectedLocationIndex + "   selectedLocationIndex")
            window.setTimeout(function () {
                navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
            }, 0)
        }*/



    }

    const [openStageTmDialog, setOpenStageTmDialog] = useState(false);
    const onHandleOpenStageTmDialog = () => { handleClose(); setOpenStageTmDialog(true); }
    const onHandleCancelStageTmDialog = () => {
        setOpenStageTmDialog(false);
        /*if (window.location.pathname === '/home') {
            navigate("/settings/stagesTimeline")
            //console.log(selectedLocationIndex + "   selectedLocationIndex")
            window.setTimeout(function () {
                navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
            }, 0)
        }*/
    }

    const [openMoreSettingDialog, setOpenMoreSettingDialog] = useState(false);
    const onHandleOpenMoreSettingDialog = () => { handleClose(); setOpenMoreSettingDialog(true); }
    const onHandleCancelMoreSettingDialog = () => {
        setOpenMoreSettingDialog(false);
        /*if (window.location.pathname === '/home') {
            navigate("/settings/moreSettings")
            //console.log(selectedLocationIndex + "   selectedLocationIndex")
            window.setTimeout(function () {
                navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
            }, 0)
        }*/
    }


    const [openTrackerDialog, setOpenTrackerDialog] = useState(false);
    const onHandleOpenTrackerDialog = () => { handleClose(); setOpenTrackerDialog(true); }
    const onHandleCancelTrackerDialog = () => {
        setOpenTrackerDialog(false);
        
        /*if (window.location.pathname === '/home') {
            navigate("/settings/Tracker")
            //console.log(selectedLocationIndex + "   selectedLocationIndex")
            window.setTimeout(function () {
                navigate("/home", { state: { name: "location", locInd: selectedLocationIndex, tabInd: "Orders" } })
            }, 0)
        }*/
    }

    const [selectedOrder, setSelectedOrder] = useState("");
    const [jobSearch, setJobSearch] = useState("");
    const [mapDisplay, setMapDisplay] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [topSearchValue, setTopSearchValue] = useState("");
    const onTopSearchCommit = value => {
        const trimmed = value?.trim();
        setTopSearchValue(value);
        setSearchText(trimmed);
        dispatch(onSearchChange(trimmed));
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const { chatCount } = useSelector(state => state.orders);
    const { chatCountC } = useSelector(state => state.orders);
    const { chatCountT } = useSelector(state => state.orders);
    const { chatCountCT } = useSelector(state => state.orders);
    const { custChatListNotification, chatListNotification } = useSelector(state => state.orders);
    const getChatCount = () => {
        return chatListNotification.length;
        return chatCount + chatCountT + chatCountC + chatCountCT;
        if (getUserInfo("department") == 1 || getUserInfo("department") == null || getUserInfo("department")==="")
            return chatCount;
        if (getUserInfo("department") == 2)
            return chatCountT;
        if (getUserInfo("department") == 3)
            return chatCountC;
    }
    const getCustChatCount = () => {
        return custChatListNotification.length;
        return chatCount + chatCountT + chatCountC + chatCountCT;
        if (getUserInfo("department") == 1 || getUserInfo("department") == null || getUserInfo("department")==="")
            return chatCount;
        if (getUserInfo("department") == 2)
            return chatCountT;
        if (getUserInfo("department") == 3)
            return chatCountC;
    }
    const open = Boolean(anchorEl);

    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [userInfo, setUserInfo] = new useState(null);

    const getUserInfo = attrName => {
        if (userInfo !== null) {
            let userInfoObj = JSON.parse(userInfo);
            return userInfoObj[attrName];
        }
        return '';
    };

    const getUserInfoJson = () => {
        if (userInfo !== null) {
            let userInfoObj = JSON.parse(userInfo);
            return userInfoObj;
        }
        return '';
    };
    const updateLoginUser = (data) => {
        setUserInfo(JSON.stringify(data));
    };
    if (location.state && location.state.isLogout === true) {
        // For logout/from new login, Should invalidate the user info object.
        setUserInfo(null);
        location.state.isLogout = false;
        location.state.isNewUser = false;
    }

    if (userInfo === null) {
        // Get the user info from server.
        // If the server returned 401, redirect to Login the page.
        sendRequest('/api/loggedInUser', REQUEST_ACTIONS.POST, '', {
            successCallback: response => {
                setUserInfo(JSON.stringify(response));
                let userInfoObj = JSON.parse(JSON.stringify(response));
                setUID(userInfoObj.id);
                let authorities = userInfoObj['authorities'];
                if (authorities && authorities[0].authority !== 'Customer' && location.pathname.indexOf('/home') === -1) {
                    if (location.pathname === '/phome') {
                        navigate('/phome', { state: { userInfo: userInfo } });
                    } else if (location.pathname === '/orderHistory') {
                        navigate('/orderHistory' + location.search, { state: { userInfo: userInfo, searchParam: searchParam } });
                    } else {
                        navigate('/home', { state: { userInfo: userInfo } });
                    }
                } else if (authorities && authorities[0].authority === 'Customer' && location.pathname.indexOf('/settings/Tracker') === -1 && location.pathname.indexOf('/customer/dashboard') === -1) {
                    navigate('/customer/dashboard', { state: { userInfo: userInfo } });
                }
            },
            failedCallback: error => {
                if (error.status === 401 || error.status === 403) {
                    setUserInfo('');
                    if (location.pathname !== '/login') {
                        navigate('/login');
                    }
                }
            },
        });
    }
    const doLogout = () => {
        sendRequest('/api/logout', REQUEST_ACTIONS.POST, null, {
            successCallback: () => {
                dispatch(getOrders([]));
                navigate('/login');
            },
            failedCallback: error => {
                console.error(error);
            },
        });
    };

    const StyledMenu = styled(props => (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            {...props}
        />
    ))(({ theme }) => ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            minWidth: 180,
            color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
            boxShadow:
                'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
                padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                '&:active': {
                    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                },
            },
        },
    }));
    const IlTime = new Date().toLocaleString("en-GB", { timeZone: 'Israel' }).split(",");
    // eslint-disable-next-line no-unused-vars
    const NlTime = new Date().toLocaleString("en-EN", { timeZone: 'Europe/Amsterdam' }).split(",");

    const Il_Time = new Date().toLocaleString("en-EN", { timeZone: 'Israel' });
    const Nl_Time = new Date().toLocaleString("en-EN", { timeZone: 'Europe/Amsterdam' });
    const Us_Time = new Date().toLocaleString("en-EN", { timeZone: 'America/Los_Angeles' });

    const IL_Time = new Date(Il_Time);
    const NL_Time = new Date(Nl_Time);
    const US_Time = new Date(Us_Time);

    const toolbarStyle = {
        minHeight: 50,
        color: 'black',
        width: 'calc(100vw - 750px)',
        justifyContent: 'flex-end'
    };

    const pathname = window.location.pathname;

    return (
        <React.Fragment>
            {userInfo && (
                <React.Fragment>
                    {pathname !== '/customer/dashboard' && pathname !== '/customer/shipments' ?
                        <div style={{}}>
                            <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDgpzrxExQg_AUW8h199onppaSz72SYlSY" />
                            <header className='topbar'>
                                <div className='brand'>
                                    <div className="login-title-strong"></div>
                                    <div className='divider' />
                                    <div className='subbrand'>Global Shipping Operations</div>
                                    <div className='divider' />
                                    <div className='meta'><span className='cal'>&#9635;</span><span>{IlTime[0] + ",  IL: " + IL_Time.getHours() + ":" + (IL_Time.getMinutes() < 10 ? "0" : "") + IL_Time.getMinutes() + ",  US: " + US_Time.getHours() + ":" + (US_Time.getMinutes() < 10 ? "0" : "") + US_Time.getMinutes()}</span></div>
                                    <div className='divider' />
                                    <div className='meta'><span>Ver: v2.0.10</span></div>
                                </div>

                                <div className='top-search'>
                                    {/*<div className='searchbox'>
                                        <span>&#8981;</span>
                                        <input
                                            placeholder='Search orders, customers, PO...'
                                            value={topSearchValue}
                                            onChange={ev => setTopSearchValue(ev.target.value)}
                                            onKeyDown={ev => {
                                                if (ev.key === 'Enter') {
                                                    onTopSearchCommit(ev.target.value);
                                                    ev.preventDefault();
                                                }
                                            }}
                                        />
                                        <kbd>&#8984; K</kbd>
                                    </div>*/}
                                </div>

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'User' && getUserInfo('department') != 4 && (
                                    <React.Fragment>
                                        <IconButton aria-label='Unread chat messages' onClick={onHandleOpenChatNotificationDialog}>
                                            <Badge badgeContent={getChatCount()} color='primary' showZero max={999}>
                                                <MarkUnreadChatAltIcon />
                                            </Badge>
                                        </IconButton>
                                        {getUserInfo('location').code === 'IL' && (
                                            <IconButton aria-label='Unread customer chat messages' onClick={onHandleOpenCustChatNotificationDialog}>
                                                <Badge badgeContent={getCustChatCount()} color='success' showZero max={999}>
                                                    <MarkUnreadChatAltIcon />
                                                </Badge>
                                            </IconButton>
                                        )}
                                        <div className='divider' />
                                    </React.Fragment>
                                )}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority != 'Customer' && (
                                    <React.Fragment>
                                        <div className='settings' onClick={handleClick} style={{ cursor: 'pointer' }}>
                                            <span>&#9881;</span><span className='settings-label'>Settings</span>
                                        </div>
                                        <div className='divider' />
                                    </React.Fragment>
                                )}

                                <div className={'dropdown welcome' + (userMenuOpen ? ' open' : '')} onClick={() => setUserMenuOpen(v => !v)}>
                                    <span className='welcome-label'>Welcome, </span><span className='dropbtn' style={{ color: '#006AE6' }}>{getUserInfo('username')}</span>
                                    <div className='dropdown-content'>
                                        <span onClick={doLogout}>Logout</span>
                                    </div>
                                </div>
                                <div className='avatar' onClick={() => setUserMenuOpen(v => !v)} style={{ cursor: 'pointer' }}>{(getUserInfo('username') || '?').charAt(0).toUpperCase()}</div>
                            </header>
                            {openChatNotificationDialog && (
                                <Dialog
                                    open={openChatNotificationDialog}
                                    onHandleCancel={onHandleCancelChatNotificationDialog}
                                    title='Chat Notifications'
                                    maxWidth='lg'>
                                    {location.pathname === '/phome' ? <ParcelChatListDialog loginUser={getUserInfoJson()} chatCount={getChatCount()} /> : <ChatListDialog setSelectedOrder={setSelectedOrder} filterSpinner={filterSpinner} setFilterSpinner={setFilterSpinner} onHandleCancelChatNotificationDialog={onHandleCancelChatNotificationDialog} setSearchText={setSearchText} loginUser={getUserInfoJson()} chatCount={getChatCount()} />}
                                </Dialog>
                            )}
                            {openCustChatNotificationDialog && (
                                <Dialog
                                    open={openCustChatNotificationDialog}
                                    onHandleCancel={onHandleCancelCustChatNotificationDialog}
                                    title='Customer Chat Notifications'
                                    maxWidth='lg'>
                                    {location.pathname === '/phome' ? <ParcelChatListDialog loginUser={getUserInfoJson()} chatCount={getCustChatCount()} /> : <CustChatListDialog onHandleCancelChatNotificationDialog={onHandleCancelCustChatNotificationDialog} setSearchText={setSearchText} loginUser={getUserInfoJson()} chatCount={getCustChatCount()} />}
                                </Dialog>
                            )}
                            {openAuditLogsDialog && (
                                <Dialog
                                    open={openAuditLogsDialog}
                                    onHandleCancel={onHandleCancelAuditLogsDialog}
                                    title='Audit Logs'
                                    fullWidth='true'
                                    maxWidth='lg'>
                                    <AuditLogs />
                                </Dialog>
                            )}
                            {openProfileDialog && (
                                <Dialog
                                    open={openProfileDialog}
                                    onHandleCancel={onHandleCancelProfileDialog}
                                    title='Profile'
                                    maxWidth='lg'>
                                    <AddUser data={getUserInfoJson()} onHandleCancel={onHandleCancelProfileDialog} id={null} viewProfile={true} />
                                </Dialog>
                            )}
                            {openUsersDialog && (
                                <Dialog
                                    open={openUsersDialog}
                                    onHandleCancel={onHandleCancelUsersDialog}
                                    title='Users'
                                    maxWidth='lg'>
                                    <Users />
                                </Dialog>
                            )}
                            {openCRMDialog && (
                                <Dialog
                                    open={openCRMDialog}
                                    onHandleCancel={onHandleCancelCRMDialog}
                                    title='CRM'
                                    maxWidth='lg'>
                                    <ServiceProvider loginUser={getUserInfoJson()} />
                                </Dialog>
                            )}
                            {openStageTmDialog && (
                                <Dialog
                                    open={openStageTmDialog}
                                    onHandleCancel={onHandleCancelStageTmDialog}
                                    title='Order Stages Timeline'
                                    maxWidth='lg'>
                                    <OrderStagesTimeline />
                                </Dialog>
                            )}

                            {openMoreSettingDialog && (
                                <Dialog
                                    open={openMoreSettingDialog}
                                    onHandleCancel={onHandleCancelMoreSettingDialog}
                                    title='More Settings'
                                    maxWidth='lg'>
                                    <PredefinedDataSettings loginUser={getUserInfoJson()} />
                                </Dialog>
                            )}

                            { openTrackerDialog && (
                                <Dialog
                                    open={openTrackerDialog}
                                    onHandleCancel={onHandleCancelTrackerDialog}
                                    title='Tracker'
                                    maxWidth='1400px'>
                                    <Tracker />
                                </Dialog>
                            ) }

                            <StyledMenu
                                id='demo-customized-menu'
                                MenuListProps={{
                                    'aria-labelledby': 'demo-customized-button',
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClick={handleClose}>

                                {/*getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'User' ? (
                                    <MenuItem onClick={onHandleOpenProfileDialog}>Profile</MenuItem>
                                ) : null */}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Admin' && <TextButton onClick={onHandleOpenAuditLogsDialog} style={{ fontSize: 17, color: 'black' }}>
                                    Audit Logs
                                </TextButton>
                                }
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'User' && <TextButton onClick={onHandleOpenProfileDialog} style={{ fontSize: 17, color: 'black' }}>
                                    Profile
                                </TextButton>
                                }
                                {getUserInfo('department') != 4 && <br />}
                                {/*{getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Admin' ? (
              <Link to='/settings/users' style={{ textDecoration: 'none', color: 'inherit', fontSize: 17 }} >
                <MenuItem onClick={handleClose}>Users</MenuItem> 
              </Link>
            ) : null}*/}
                                {/*<Grid container justifyContent="flex-start">*/}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Admin' && <TextButton onClick={onHandleOpenUsersDialog} style={{ fontSize: 17, color: 'black' }}>
                                    Users
                                </TextButton>
                                }
                               {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Admin' &&  <br/>}
                               {/* <Link to='/settings/serviceProviders' style={{ textDecoration: 'none', color: 'inherit', fontSize: 17 }}>
                                    <MenuItem onClick={handleClose}>CRM</MenuItem> 
                                </Link>*/}
                                {getUserInfo('department') != 4 && <TextButton onClick={onHandleOpenCRMDialog} style={{ fontSize: 17, color: 'black' }}>
                                    CRM
                                </TextButton>}
                                {getUserInfo('department') != 4 && <br />}
                                {getUserInfo('authorities') && getUserInfo('department') != 4 && getUserInfo('authorities')[0].authority !== 'Customer' &&<TextButton onClick={onHandleOpenStageTmDialog} style={{ fontSize: 17, color: 'black' }}>
                                    Order Stages Timeline
                                </TextButton>
                                }
                                {getUserInfo('department') != 4 && <br />}
                                {getUserInfo('authorities') && getUserInfo('department') != 4 && getUserInfo('authorities')[0].authority !== 'Customer' &&<TextButton onClick={onHandleOpenMoreSettingDialog} style={{ fontSize: 17, color: 'black' }}>
                                    More Settings
                                </TextButton>
                                }
                                {/*<br />
                                
                                { getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' && <TextButton onClick={onHandleOpenTrackerDialog} style={{ fontSize: 17, color: 'black', width:"!00%" }}>
                                    Tracker
                                </TextButton>
                                }*/}

                               {/* <Link to='/settings/stagesTimeline' style={{ textDecoration: 'none', color: 'inherit', fontSize: 17 }}>
                                    <MenuItem onClick={handleClose}>Order Stages Timeline</MenuItem>
                                </Link>*/}
                                {/*<Link to='/settings/moreSettings' style={{ textDecoration: 'none', color: 'inherit', fontSize: 17 }}>
                                    <MenuItem onClick={handleClose}>More Settings</MenuItem>
                                </Link>*/}
                                {/*<Link to='/settings/Tracker' style={{ textDecoration: 'none', color: 'inherit', fontSize: 17 }}>
                                    <MenuItem onClick={handleClose}>Tracker</MenuItem>
                                </Link>*/}
                                   {/* </Grid>*/}
                            </StyledMenu>
                            {selectedOrder && <CustomsUIPage loginUser={getUserInfoJson()} order1={selectedOrder} setSelectedOrder={setSelectedOrder} /> }
                            {<Routes>
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/home' element={<Orders selectedOrder={selectedOrder} setSelectedOrder={setSelectedOrder} filterSpinner={filterSpinner} setFilterSpinner={setFilterSpinner} isTrackerLoaded={false} setIsUsTime={setIsUsTime} redboxParcels={function () {
                                        //navigate('/phome');
                                        window.location.assign(window.location.origin + "/phome")
                                    }} agentOrders={function () {
                                        // navigate('/home');
                                        window.location.assign(window.location.origin + "/home")
                                    }} loginUser={getUserInfoJson()} key="orders" setSearchText={setSearchText} searchText={searchText} />} />
                                ) : null}{
                                    getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                        <Route exact path='/tracker' element={<Orders selectedOrder={selectedOrder} filterSpinner={filterSpinner} setFilterSpinner={setFilterSpinner} isTrackerLoaded={true} setIsUsTime={setIsUsTime} redboxParcels={function () {
                                            //navigate('/phome');
                                            window.location.assign(window.location.origin + "/phome")
                                        }} agentOrders={function () {
                                            // navigate('/home');
                                            window.location.assign(window.location.origin + "/home")
                                        }} loginUser={getUserInfoJson()} key="orders" />} />
                                    ) : null}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/phome' element={<Parcels setIsUsTime={setIsUsTime} redboxParcels={function () {
                                        //  navigate('/phome');
                                        window.location.assign(window.location.origin + "/phome")
                                        //console.log(window.location)
                                    }} agentOrders={function () {
                                        //navigate('/home');
                                        window.location.assign(window.location.origin + "/home")
                                    }} loginUser={getUserInfoJson()} key="Parcels" />} />
                                ) : null}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/dhome' element={<Parcels setIsUsTime={setIsUsTime} redboxParcels={function () {
                                        //  navigate('/phome');
                                        window.location.assign(window.location.origin + "/phome")
                                        //console.log(window.location)
                                    }} agentOrders={function () {
                                        //navigate('/home');
                                        window.location.assign(window.location.origin + "/home")
                                    }} loginUser={getUserInfoJson()} key="drops" />} />
                                ) : null}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route path='/orderHistory' element={<HistoryOrders selectedOrder={selectedOrder} setSelectedOrder={setSelectedOrder} filterSpinner={filterSpinner} setFilterSpinner={setFilterSpinner} setIsUsTime={setIsUsTime} redboxParcels={function () {
                                        //  navigate('/phome');
                                        window.location.assign(window.location.origin + "/phome")
                                        //console.log(window.location)
                                    }} agentOrders={function () {
                                        //navigate('/home');
                                        window.location.assign(window.location.origin + "/home")
                                    }} loginUser={getUserInfoJson()} />} key="ordersHistory" />
                                ) : null}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/parcelHistory' element={<ParcelHistoryOrders setIsUsTime={setIsUsTime} redboxParcels={function () {
                                        //  navigate('/phome');
                                        window.location.assign(window.location.origin + "/phome")
                                    }} agentOrders={function () {
                                        //navigate('/home');
                                        window.location.assign(window.location.origin + "/home")
                                    }} loginUser={getUserInfoJson()} key="parcelsHistory" />} />
                                ) : null}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/dropHistory' element={<ParcelHistoryOrders setIsUsTime={setIsUsTime} redboxParcels={function () {
                                        //  navigate('/phome');
                                        window.location.assign(window.location.origin + "/phome")
                                    }} agentOrders={function () {
                                        //navigate('/home');
                                        window.location.assign(window.location.origin + "/home")
                                    }} loginUser={getUserInfoJson()} key="dropHistory" />} />
                                ) : null}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' && !(getUserInfo('authorities') && getUserInfo('authorities')[0]?.authority === 'User' && getUserInfo('location')?.code === 'IL') ? (
                                    <Route exact path='/manifest' element={<Manifest loginUser={getUserInfoJson()} />} />
                                ) : null}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/manifestHistory' element={<ManifestHistory loginUser={getUserInfoJson()} />} />
                                ) : null}
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/settings/serviceProviders' element={<ServiceProvider loginUser={getUserInfoJson()} />} />
                                ) : null}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Admin' ? (
                                    <Route exact path='/settings/users' element={<Users />} />
                                ) : null}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/settings/stagesTimeline' element={<OrderStagesTimeline />} />
                                ) : null}

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority !== 'Customer' ? (
                                    <Route exact path='/settings/moreSettings' element={<PredefinedDataSettings loginUser={getUserInfoJson()} />} />
                                ) : null}

                                <Route exact path='/settings/Tracker' element={<Tracker />} />

                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Customer' ? (
                                    <Route exact path='/customerOrders' element={<CustomerOrders loginUser={getUserInfoJson()} />} />
                                ) : null}
                            </Routes>}
                        </div>
                        : <CustomerConatiner setChatOpenOrder={setChatOpenOrder} chatOpenFunction={chatOpenFunction} chatCount={chatCountCust} onHandleOpenCustomerNotification={onHandleOpenCustomerNotification} loginUser={getUserInfoJson()} logoutUser={doLogout} jobSearch={jobSearch} setJobSearch={setJobSearch} mapDisplay={mapDisplay} setMapDisplay={setMapDisplay}>
                            <Routes>
                                {getUserInfo('authorities') && getUserInfo('authorities')[0].authority === 'Customer' ? (
                                    <React.Fragment>
                                        <Route exact path='/customer/dashboard' element={<CustomerDashboard chatOpenOrder={chatOpenOrder} setChatOpenOrder={setChatOpenOrder} setChatOpenFunction={setChatOpenFunction} setChatCount={setChatCountCust} loginUser={getUserInfoJson()} jobSearch={jobSearch} setJobSearch={setJobSearch} mapDisplay={mapDisplay} setMapDisplay={setMapDisplay} />} />
                                        <Route exact path='/customer/shipments' element={<CustomerShipments chatOpenOrder={chatOpenOrder} setChatOpenOrder={setChatOpenOrder} setChatOpenFunction={setChatOpenFunction} setChatCount={setChatCountCust} loginUser={getUserInfoJson()} jobSearch={jobSearch} setJobSearch={setJobSearch} mapDisplay={mapDisplay} setMapDisplay={setMapDisplay} />} />
                                    </React.Fragment>
                                ) : null}
                            </Routes>
                        </CustomerConatiner>}
                    {getUserInfo('fullName') === "root" && <OrderAssistant />}
                    {showCustomerNotification && <Settings
                        onHandleCancelCustomerNotification={onHandleCancelCustomerNotification}
                        loginUser={getUserInfoJson()}
                        updateLoginUser={updateLoginUser}
                    />}

                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default MainPage;
